import Vue from 'vue'
import Router from 'vue-router'
import fileSong from '@/views/fileSong'
import songList from '@/views/songList'
import index from '@/views/index'
import about from '@/views/about'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, {
    path: '/index',
    name: 'indexs',
    component: index
  }, {
      path: '/fileSong',
      name: 'fileSong',
      component: fileSong
    },
    {
      path: '/songList',
      name: 'songList',
      component: songList
    },
    {
      path: '/about',
      name: 'about',
      component: about
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js